// Import base react components
import React, {Component, PropTypes} from 'react';
import {Table, Thead, Th, Tr, Td} from 'components/reactable'

// Import components
import { SketchPicker } from 'react-color';

// Import libraries
import i18n from 'lib/i18n'
import c from 'state/constants'
import underscore from 'underscore'

// Import styles and object styles for modals
import styles from '../taskList.scss'

// Setup translation group to agenda2
const _ = i18n('agenda2')

/**
 * Manage color picker form
 *
 * Handles create and edit form for custom colors
 */
export default class ManageColorPickerForm extends Component {

    /**
	 * Set the required property types for the component
	 */
	static propTypes = {
		formState: React.PropTypes.object.isRequired,
		createAction: React.PropTypes.func.isRequired,
		updateAction: React.PropTypes.func.isRequired,
		toggleModal: React.PropTypes.func.isRequired,
		formCleanAction: React.PropTypes.func.isRequired,
		userColors: React.PropTypes.array.isRequired,
	}

	/**
     * Setup constructor with the base state of the component
     * Here we add the default state form task form fields and validation
     */
    constructor(props) {
        super(props)

        this.state = {
			form: {
				title: '',
				colorCode: '#000000',
			},
			validation: {
				title: null,
				colorCode: null,
			}
		}
	}

	/**
	 * Setup component state if the form is in edit state
	 */
	componentWillMount () {
		const { colorId, isEdit } = this.props.formState
		const { userColors } = this.props

		if(isEdit == true)
		{
			userColors.map((value, index) => {
				if(value.value == colorId)
				{
					this.setState({form: {
						title: value.label,
						colorCode: value.colorCode
					}})
				}
			})
		}
	}

	/**
     * Handles title change
     */
    handleTitleChange(event)
	{
		let { form } = this.state
		form.title = event.target.value

		this.setState({form: form})
	}

	/**
	 * Handles color change for sketch picker
	 */
	handleColorChange(color) {
		const { form } = this.state
		form.colorCode = color.hex

		this.setState({form: form})
	}

	/**
     * Handles submit if the validation was ok
     */
    handleSubmit(event)
    {
		const { form } = this.state
		const { formState, createAction, updateAction } = this.props


        // Clean the validation on every submit
		this.setState({
            validation: {
				title: null,
				description: null,
				date: null,
				color: null,
            }
		})

        // If validation was true then create task
		if(this.validate())
		{
			if(formState.isEdit == false)
			{
				createAction(form)
			}
			else
			{
				form.id = formState.colorId
				updateAction(form)
			}
		}
    }

    /**
     * Validate form after submit to check if required fields are ok
     */
	validate()
	{
		let { form, validation } = this.state
		let invalidFields = false;

		if(form.title == '' || form.title == null)
		{
			validation.title = _('requiredField')
			invalidFields = true
		}

		if(invalidFields == true)
		{
			this.setState({validation: validation})
			return false;
		}
		else
		{
			return true;
		}
	}

    /**
     * Render
     * Handles the render part for the component
     */
    render() {
		const { title, colorCode } = this.state.form
		const { validation } = this.state

		const { toggleModal, formCleanAction, formState } = this.props

		let submitButtonText = (formState.isEdit == true) ? 'edit' : 'create'

		return (
			<div className={styles.todoModalContent + " " + styles.colSm}>
				{ formState.isEdit == false && <span className={styles.title}>{_("addTodoColor")}</span> }
				{ formState.isEdit == true && <span className={styles.title}>{_("editTodoColor")}</span> }

				<label>{_('title')}</label>
                <input
                    type="text"
                    onChange={(ev) => this.handleTitleChange(ev)}
                    value={title}
                />
				<div className={ styles.error }> {validation.title != null && validation.title } </div>

				<label>{_('selectColor')}</label>
				<div className={styles.colorPickerWrapper}>
					<SketchPicker
						disableAlpha={true}
						presetColors={[]}
						className={styles.customSketchPicker}
						color={colorCode}
						onChange={ this.handleColorChange.bind(this) }
					/>
					<div style={{
						background: colorCode,
						width: '60px',
						height: '40px',
						display: 'block',
						margin: '0px 0px 0px 5px',
					}}></div>
				</div>

				<div className={styles.todoModalButtons}>
					<span
						onClick={() => {
                            toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_COLOR_PICKER)
							formCleanAction('manageColorPicker')
                        }}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
					<input
						onClick={(event) => this.handleSubmit(event)}
						type="button"
						className={styles.greyButton}
						value={_(submitButtonText)}
					/>
				</div>
			</div>
		)
    }

}



// WEBPACK FOOTER //
// ./components/taskList/components/manageColorPickerForm.jsx